import { useQuery } from '@tanstack/react-query';

import { Rental } from 'src/modules/retrieveSelfCheckIn/types';

import { getSciData, useSciKey } from './useSci';

export const useGetRental = (): Rental | undefined => {
    const { data: rental } = useQuery({
        queryKey: [useSciKey],
        queryFn: getSciData,
        select: (data) => data?.rental,
    });

    return rental;
};
